// extracted by mini-css-extract-plugin
export default {"surveyError":"surveyError___e7812784e3e6a09d"};